/* Coldest Virtual Collection — Sold-Out Click Guard v1
   Belt-and-suspenders to CSS pointer-events:none.
   Captures clicks on any .drop-card.drop-card--oos and stops them. */
(function () {
  'use strict';

  function block(e) {
    var card = e.target.closest && e.target.closest('.drop-card.drop-card--oos');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  // Capture phase so we beat any internal handlers
  ['click', 'mousedown', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      block(e);
    }, true);
  });

  // Also nuke href attributes on sold-out card links once rendered
  function disarm() {
    document.querySelectorAll('.drop-card.drop-card--oos a').forEach(function (a) {
      if (a.hasAttribute('href') && !a.dataset.cldstOrigHref) {
        a.dataset.cldstOrigHref = a.getAttribute('href');
        a.removeAttribute('href');
        a.setAttribute('aria-disabled', 'true');
        a.setAttribute('tabindex', '-1');
        a.style.cursor = 'not-allowed';
      }
    });
    document.querySelectorAll('.drop-card.drop-card--oos button, .drop-card.drop-card--oos .drop-card-atc').forEach(function (b) {
      b.setAttribute('disabled', 'disabled');
      b.setAttribute('aria-disabled', 'true');
      b.style.cursor = 'not-allowed';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disarm);
  } else {
    disarm();
  }
  // Drop grid renders async via coldest-drop-collections; observe and re-apply
  var mo = new MutationObserver(function () { disarm(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Stop observing after 15 seconds (drop grid is settled by then)
  setTimeout(function () { mo.disconnect(); disarm(); }, 15000);
})();
